<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  isDragOver: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const resolvedTitle = computed(
  () => props.title || t('PLANNING.EVENTS.DOCUMENT_ANALYSIS.DROP_HINT')
);
const resolvedSubtitle = computed(
  () => props.subtitle || t('PLANNING.EVENTS.DOCUMENT_ANALYSIS.DROP_FORMATS')
);
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-200"
    leave-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isDragOver"
      class="fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center"
    >
      <div
        class="bg-white dark:bg-slate-800 border-2 border-dashed border-woot-200 dark:border-woot-600 rounded-lg p-12 text-center shadow-lg"
      >
        <Icon
          icon="i-lucide-upload-cloud"
          class="w-16 h-16 mx-auto mb-4 text-woot-75 dark:text-slate-800"
        />
        <h3
          class="text-lg font-semibold text-slate-600 dark:text-slate-400 mb-2"
        >
          {{ resolvedTitle }}
        </h3>
        <p class="text-sm text-slate-700 dark:text-slate-300">
          {{ resolvedSubtitle }}
        </p>
      </div>
    </div>
  </Transition>
</template>
